import { globalCss } from './stitches.config'
import { DropdownList, DropdownWrap, scrollBar } from './globalStyleCss'
import { InputBoxStyle } from 'components/elements'
import {
  anchorStyles,
  h6Styles,
  paraStyles,
  tooltipStyles,
} from 'components/elements/styleText'

export const globalStyles = globalCss({
  'html': {
    fontSize: '16px',
    boxSizing: 'border-box',
    colorScheme: 'dark',
    overflow: 'hidden',
  },
  '*, *:before, *:after': {
    boxSizing: 'inherit',
  },
  'body': {
    ...scrollBar,
    'fontFamily': '$Inter',
    'backgroundColor': '$whiteBase',
    'color': '$text',
    'WebkitFontSmoothing': 'antialiased',
    'MozOsxFontSmoothing': 'grayscale',
    'textRendering': 'optimizeLegibility',
    'overflowX': 'hidden',
    'margin': 0,
    '& > div ~ .moveable-list': {
      zIndex: '1300 !important',
    },
    '& > .MuiTableRow-root': {
      'display': 'flex',
      'position': 'absolute',
      'left': 0,
      'right': 0,

      '.MuiTableCell-root': {
        'display': 'flex',
        'alignItem': 'center',
        'justifyContent': 'center',

        '&:nth-child(2)': {
          minWidth: 350,
        },
      },
    },
  },
  'input': {
    '&:-webkit-autofill, &:-webkit-autofill:hover, &:-webkit-autofill:focus': {
      'borderColor': '$inputBorderFocus',
      '-webkit-text-fill-color': '#101828',
      '-webkit-box-shadow': '0 0 0px 1000px #F9FAFB inset',
      'transition': 'background-color 5000s ease-in-out 0s',
      'borderRadius': '$radii$sm',
    },
    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '&[type=number]::-webkit-inner-spin-button ,&[type=number]::-webkit-outer-spin-button':
      {
        ' -webkit-appearance': 'none',
        ' -moz-appearance': 'none',
        'appearance': 'none',
        'margin': 0,
      },
  },
  '.pac': {
    '&-container': {
      ...DropdownWrap,
      'span:last-child:not(.pac-matched)': {
        ...paraStyles,
      },
      '.pac-matched': {
        fontWeight: '$medium',
        color: '$primaryBase',
      },
      '&:after': {
        display: 'none',
      },
    },
    '&-item': {
      'display': 'flex',
      'alignItems': 'flex-start',
      'p': '$space$10 $space$14',
      'mb': '$space$2',
      'cursor': 'pointer',
      'border': 0,
      '&-query': {
        ...h6Styles,
      },
    },
    '&-icon-marker': {
      background: 'url("./assets/icons/markerPin.svg") center center no-repeat',
      width: 20,
      m: '0 $space$8 0 0',
    },
  },
  'video': {
    maxWidth: '100%',
  },
  '.primary': {
    color: '$primaryBase',
  },
  '.gray3': {
    color: '$gray3',
  },
  '.fontBold': {
    fontWeight: '$bold',
  },
  'a': {
    ...anchorStyles,
  },
  '.MuiTouchRipple': {
    '&-root': {
      'span.MuiTouchRipple-child': {
        backgroundColor: '$gray100',
      },
    },
  },
  'svg': {
    path: {
      transition:
        'stroke .6s $transition$easeOutQuint, fill .6s $transition$easeOutQuint',
    },
  },
  '.minWidth': {
    '&-50': {
      minWidth: 50,
    },
    '&-75': {
      minWidth: 75,
    },
    '&-100': {
      minWidth: 100,
    },
    '&-125': {
      minWidth: 125,
    },
    '&-150': {
      minWidth: 150,
    },
    '&-175': {
      minWidth: 175,
    },
    '&-200': {
      minWidth: 200,
    },
    '&-225': {
      minWidth: 225,
    },
    '&-250': {
      minWidth: 250,
    },
  },
  '.errorField': {
    display: 'block',
    fontSize: '$14',
    lineHeight: '$lineHeight$20',
    marginTop: '$4 !important',
  },
  '.otpContainer': {
    justifyContent: 'center',
  },
  '.otpInput': {
    'fontSize': '$48',
    'lineHeight': '$lineHeight$60',
    'fontWeight': '$medium',
    'width': '$size$64 !important',
    'height': '$size$64',
    'p': '$space$2 $space$8',
    'color': '$inputBorder',
    'background': '$inputBg',
    'border': '1px solid',
    'borderColor': '$inputBorder',
    'borderRadius': '$radii$sm',
    'outline': 'none',
    '&:focus': {
      'borderColor': '$primaryBorderFocus',
      '&-visible': {
        borderColor: '$primaryBorderFocus',
      },
    },
  },
  '.hasImageError, .noImage': {
    '& ~ div': {
      'background': 'transparent',
      'h6, h5, p': {
        color: '$blackBase',
      },
    },
  },
  '#pagination': {
    '&-id': {
      '.Mui': {
        '&Paper-root': {
          ...DropdownWrap,
        },
      },
      '.MuiList-root': {
        p: 0,
      },
      '.MuiMenuItem-root': {
        ...DropdownList,
        '&.Mui-selected': {
          'background': '$gray50',
          '&:hover': {
            background: '$gray100',
          },
        },
      },
    },
  },
  '.map-container': {
    height: '100%',
    width: '100%',
  },
  '.MuiTooltip-popper': {
    '.MuiTooltip-tooltip': {
      backgroundColor: '$gray600',
      padding: '$8 $12',
      borderRadius: '8px',
    },
    '.MuiTooltip-arrow': {
      color: '$gray600',
    },
  },
  '.infiniteBox': {
    ...scrollBar,
  },
  '.moveable-list': {
    // height: '71px !important',
  },
  '.MuiYearCalendar-root': {
    ...scrollBar,
    '&::-webkit-scrollbar': {
      width: 6,
    },
  },
  '.rcp': {
    // 'width': 280,
    '&-root': {
      '.rcp': {
        // '&-interactive': {
        //   width: '100%',
        // },
        // '&-hue': {
        //   Width: '100%',
        // },
        // '&-saturation': {
        //   width: '100%',
        // },
        '&-field-input': {
          background: '$gray600',
        },
      },
    },
  },
  '.sketch-picker': {
    input: {
      ...InputBoxStyle,
      color: '$gray800',
      borderRadius: '$radii$xs',
    },
  },
  '.MuiMultiSectionDigitalClock-root': {
    ul: {
      'width': 'auto',
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    },
    li: {
      ...tooltipStyles,
      fontWeight: '$normal',
      m: '$space$4',
      px: '$space$6',
      width: 36,
      height: 36,
      borderRadius: '$radii$rounded',
    },
  },
})

globalStyles()
